import { buildCreateSlice, asyncThunkCreator } from '@reduxjs/toolkit';

import { initialState } from './initial';
import { reducers } from './reducers';

export const createAppSlice = buildCreateSlice({
  creators: { asyncThunk: asyncThunkCreator },
});

export const announcementsSlice = createAppSlice({
  name: 'announcements',
  initialState,
  reducers,
});

export const {
  fetchAnnouncements,
  saveAnnouncementV2,
  updateAnnouncementV2,
  deleteAnnouncement,
  cancelAnnouncementV2,
} = announcementsSlice.actions;

export default announcementsSlice.reducer;
